import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Modal from '../Modal';
import Carousel from '../Carousel';
import RichText from '../Prismic/RichText';
import Price from '../Price';
import Button from 'wonderbly-components/lib/Button';
import Panel from 'wonderbly-components/lib/Panel';
import { prismicImage } from 'src/common/utils/prismic-image';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import './LookInside.scss';

const LookInside = props => {
  const hasSlider = !isEmpty(props.slider);
  return (
    <Modal
      bypass={!props.isOpen}
      className="look-inside-modal"
      default
      isOpen>
      {!props.isOpen && props.handleOpenModal &&
      <Button
        onClick={props.handleOpenModal}
        className={cx('look-inside-btn--open', {
          [`${props.for}-look-inside-btn--open`]: !!props.for
        })}>{props.openCta}</Button>
      }
      {props.isOpen && (
        <div
          className={cx('look-inside', {
            'look-inside--no-slider': !hasSlider
          })}>
          {props.closeCta && props.handleCloseModal &&
          <Button
            className="look-inside-btn--close"
            onClick={props.handleCloseModal}
            unstyled>
            {props.closeCta}
          </Button>
          }
          <Panel
            className="panel--default look-inside-panel">
            {hasSlider &&
              <div className="look-inside-slider">
                <Carousel>
                  {props.slider.map(image => (
                    <img
                      key={image.url}
                      src={prismicImage(image)}
                      alt={image.alt || ''}
                      width={`${get(image, 'dimensions.width', 900) / 2}px`}
                    />
                  ))}
                </Carousel>
              </div>
            }
            <div className="look-inside-container">
              <div className="look-inside-content">
                <RichText fields={props.title} className="look-inside-title" />
                <div className="look-inside-info">
                  {props.tagline &&
                  <h4 className="text-kilo look-inside-tagline">{props.tagline}</h4>
                  }
                  {props.price && props.priceString &&
                    <Price
                      className="look-inside-price"
                      price={props.price}
                      priceString={props.priceString}
                      savings={props.savings}
                      savingPriceString={props.savingPriceString}
                    />
                  }
                </div>
                <RichText fields={props.description} className="look-inside-description" />
                {props.reviewContent && props.reviewerName &&
                <Fragment>
                  <RichText fields={props.reviewContent} className="look-inside-review-content" />
                  <div className="look-inside-reviewer">{props.reviewerName}</div>
                </Fragment>
                }
              </div>
              <div className="look-inside-buttons">
                {props.mainCta && props.handleAcceptModal &&
                <Button
                  className="look-inside-btn--main"
                  onClick={props.handleAcceptModal}
                  colour="green"
                  fullWidth
                  raised>
                  {props.mainCta}
                </Button>
                }
                {props.cancelCta && props.handleCancelModal &&
                <Button
                  className="look-inside-btn--cancel"
                  onClick={props.handleCancelModal}
                  fullWidth
                  unstyled>
                  {props.cancelCta}
                </Button>
                }
              </div>
            </div>
          </Panel>
        </div>
      )}
    </Modal>
  );
};

LookInside.propTypes = {
  isOpen: PropTypes.bool,
  for: PropTypes.string,
  slider: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    dimensions: PropTypes.shape({
      width: PropTypes.number.isRequired,
    }).isRequired
  })),
  title: PropTypes.array,
  tagline: PropTypes.string,
  price: PropTypes.object.isRequired,
  priceString: PropTypes.string.isRequired,
  savings: PropTypes.object,
  savingPriceString: PropTypes.string,
  description: PropTypes.array,
  reviewContent: PropTypes.array,
  reviewerName: PropTypes.string,
  openCta: PropTypes.string,
  closeCta: PropTypes.string,
  mainCta: PropTypes.string,
  cancelCta: PropTypes.string,
  handleOpenModal: PropTypes.func,
  handleCloseModal: PropTypes.func,
  handleAcceptModal: PropTypes.func,
  handleCancelModal: PropTypes.func,
};

export default LookInside;



// WEBPACK FOOTER //
// ./src/client/js/view/components/LookInside/LookInside.js